import { useEffect, useRef } from "react";
import './drop.css'
import CryptoImage from "../../../../../assets/images/crypto-com.jpg";
export function DropImage() {
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && imgRef.current) {
          imgRef.current.classList.add("in-view");
          observer.disconnect(); // only once
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <img
      ref={imgRef}
      className="drop-img-footer"
      src={CryptoImage}
      alt="Crypto Logo"
    />
  );
}
